export default (requests, axios) => {
    return {
        getExternalBetHistory: (data) => {
            return requests.post(`/games/history`, data);
        },
    }
};
